import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';
import { formatStreamsData, formatDevicesData, formatViewersData } from './helper';
import { AdContentTabKey, DevicesTabKey, StreamsTabKey, ViewersTabKey } from './reducer';
import { formatAdContentData } from './adContentHelper';
import { selectedBarIndexSelector } from '../impactedViewers/selectors';

const selector = state => get(state, SCOPE);

export const activeTabSelector = createSelector(selector, state => state.activeTab);
const streamsSelector = createSelector(selector, state => state[StreamsTabKey]);
const devicesSelector = createSelector(selector, state => state[DevicesTabKey]);
const adContentSelector = createSelector(selector, state => state[AdContentTabKey]);
const viewersSelector = createSelector(selector, state => state[ViewersTabKey]);

export const streamsLoadingSelector = createSelector(streamsSelector,
  state => ({
    loading: state.isFetching,
    showError: state.errorCode !== 0,
    errorMsg: state.errorMsg,
  }));

export const streamsDataSelector = createSelector(streamsSelector,
  (state ) => {
    return formatStreamsData(state)
  },
);

export const devicesLoadingSelector = createSelector(devicesSelector,
  state => ({
    loading: state.isFetching,
    showError: state.errorCode !== 0,
    errorMsg: state.errorMsg,
  }));

export const devicesDataSelector = createSelector(devicesSelector,
  (state ) => {
    return formatDevicesData(state)
  },
);

export const viewersLoadingSelector = createSelector(viewersSelector,
  state => ({
    loading: state.isFetching,
    showError: state.errorCode !== 0,
    errorMsg: state.errorMsg,
  }));

export const viewersDataSelector = createSelector(
  viewersSelector,
  selectedBarIndexSelector,
  (state, selectedBarIndex) => {
    return formatViewersData(state, selectedBarIndex)
  },
);

export default selector;
